/** "client" module DTOs unique keys */
export enum ClientDtoKeysEnum {
  /** Bank details collapse API request body */
  BANK_DETAILS_COLLAPSE_FORM_DTO = 'client/bank-details-collapse-form.dto',
  /** Bank details duplicate relations statistics */
  BANK_DETAILS_DUPLICATE_STAT_DTO = 'client/bank-details-duplicate-stat.dto',
  /** Bank details duplicate data */
  BANK_DETAILS_DUPLICATE_DTO = 'client/bank-details-duplicate.dto',
  /** Bank details duplicates group response body */
  BANK_DETAILS_DUPLICATES_GROUP_DTO = 'client/bank-details-duplicates-group.dto',
  /** Bank details duplicates search API response body */
  BANK_DETAILS_DUPLICATES_PAGE_DTO = 'client/bank-details-duplicates-page.dto',
  /** Bank details duplicates search API query parameters */
  BANK_DETAILS_DUPLICATES_QUERY_DTO = 'client/bank-details-duplicates-query.dto',
  /** All bank details list API query parameters */
  BANK_DETAILS_QUERY_DTO = 'client/bank-details-query.dto',
  /** Bank details response body */
  BANK_DETAILS_FIND_DTO = 'client/bank-details-find.dto',
  /** Bank details creation request body */
  BANK_DETAILS_FORM_DTO = 'client/bank-details-form.dto',
  /** Bank details updating request body */
  BANK_DETAILS_UPDATE_FORM_DTO = 'client/bank-details-update-form.dto',
  /** Additional client deletion options */
  CLIENT_DELETE_QUERY_DTO = 'client/client-delete-query.dto',
  /** Client list APIs common query parameters */
  CLIENT_FILTERS_DTO = 'client/client-filters.dto',
  /** Client find one API query parameters with additional options */
  CLIENT_FIND_ONE_QUERY_DTO = 'client/client-find-one-query.dto',
  /** Response body for client - logical group of counterparties. */
  CLIENT_FIND_DTO = 'client/client-find.dto',
  /** Client create or update request body */
  CLIENT_FORM_DTO = 'client/client-form.dto',
  /** Clients flat list API query parameters */
  CLIENTS_LIST_FLAT_QUERY_DTO = 'client/clients-list-flat-query.dto',
  /** Clients list API query parameters */
  CLIENTS_LIST_QUERY_DTO = 'client/clients-list-query.dto',
  /** Clients list slice response body */
  CLIENTS_LIST_PAGE_DTO = 'client/clients-list-page.dto',
  /** Client documents widget response body */
  CLIENT_DOCUMENTS_WIDGET_FIND_DTO = 'client/client-documents-widget-find.dto',
  /** Client BRS tasks widget data - last N created BRS tasks and total number of BRS tasks */
  CLIENT_BRS_TASKS_WIDGET_FIND_DTO = 'client/client-brs-tasks-widget-find.dto',
  /** Client deals widget data - last N created deals and total number of deals */
  CLIENT_DEALS_WIDGET_FIND_DTO = 'client/client-deals-widget-find.dto',
  /** Client helpdesk tasks widget data - last N created HD tasks and total number of HD tasks */
  CLIENT_HELPDESK_TASKS_WIDGET_FIND_DTO = 'client/client-helpdesk-tasks-widget-find.dto',
  /** Client projects widget data - last N created projects and total number of projects */
  CLIENT_PROJECTS_WIDGET_FIND_DTO = 'client/client-projects-widget-find.dto',
  /** Client deals widget query params */
  CLIENT_DEALS_WIDGET_QUERY_DTO = 'client/client-deals-widget-query.dto',
  /** Client projects widget query params */
  CLIENT_PROJECTS_WIDGET_QUERY_DTO = 'client/client-projects-widget-query.dto',
  /** Client documents widget query params */
  CLIENT_DOCUMENTS_WIDGET_QUERY_DTO = 'client/client-documents-widget-query.dto',
  /** Client HD tasks widget query params */
  CLIENT_HELPDESK_TASKS_WIDGET_QUERY_DTO = 'client/client-helpdesk-tasks-widget-query.dto',
  /** Counterparty delete API query parameters (additional options) */
  CONTRAGENT_DELETE_QUERY_DTO = 'clients/contragent-delete-query.dto',
  /** Counterparty response body */
  CONTRAGENT_FIND_DTO = 'client/contragent-find.dto',
  /** Counterparty create or update requests body */
  CONTRAGENT_FORM_DTO = 'client/contragent-form.dto',
  /** Counterparties list JSON "page" query parameters */
  CONTRAGENT_PAGE_QUERY_DTO = 'client/contragent-page-query.dto',
  /** Counterparties list JSON "page" */
  CONTRAGENT_PAGE_DTO = 'client/contragent-page.dto',
  /** Contragent partial update request body */
  CONTRAGENT_PARTIAL_FORM_DTO = 'client/contragent-partial-form.dto',
  /** Counteparties lists APIs base query parameters */
  CONTRAGENT_QUERY_DTO = 'client/contragent-query.dto',
  /** Related counterparty objects statistics */
  CONTRAGENT_RELATED_OBJECTS_STAT_DTO = 'client/contragent-related-objects-stat.dto',
  /** Numbers of counterparty relations */
  CONTRAGENT_RELATIONS_COUNTS_DTO = 'client/contragent-relations-counts.dto',
  /** Duplicated counterparty */
  CONTRAGENT_DUPLICATE_DTO = 'client/contragent-duplicate.dto',
  /** Group of duplicated counterparties */
  CONTRAGENT_DUPLICATES_GROUP_DTO = 'client/contragent-duplicates-group.dto',
  /** Duplicated counterparties slice */
  CONTRAGENT_DUPLICATES_PAGE_DTO = 'client/contragent-duplicates-page.dto',
  /** Counterparties collapse request body */
  CONTRAGENT_COLLAPSE_FORM_DTO = 'client/contragent-collapse-form.dto',
  /** Counterparty history response */
  CONTRAGENT_HISTORY_FIND_DTO = 'client/contragent-history-find.dto',
  /** Counterparty history page response */
  CONTRAGENT_HISTORY_PAGE_DTO = 'client/contragent-history-page.dto',
  /** Common person (company or counterparty) response body */
  PERSON_FIND_DTO = 'client/person-find.dto',
  /** Common person (company or counterparty) create or update request body */
  PERSON_FORM_DTO = 'client/person-form.dto',
  /** Person external search query parameters */
  PERSON_EXTERNAL_SEARCH_QUERY_DTO = 'client/person-external-search-query.dto',
  /** Person passport data */
  PERSON_PASSPORT_DATA_DTO = 'client/person-passport-data.dto',
  /** Person find base query parameters */
  PERSON_FIND_BASE_QUERY_DTO = 'client/person-find-base-query.dto',
  /** Activity response body */
  ACTIVITY_FIND_DTO = 'client/contragent/activity-find.dto',
  /** Activity create or update requests body */
  ACTIVITY_FORM_DTO = 'client/contragent/activity-form.dto',
  /** Activity list JSON "page" */
  ACTIVITY_PAGE_DTO = 'client/contragent/activity-page.dto',
  /** Activity APIs base query parameters */
  ACTIVITY_QUERY_DTO = 'client/contragent/activity-query.dto',
  /** Company response body */
  COMPANY_FIND_DTO = 'company/company-find.dto',
  /** Company query params body */
  COMPANY_FIND_QUERY_DTO = 'company/company-find-query.dto',
  /** Company list response body */
  COMPANY_FIND_RESULT_DTO = 'company/company-find-result.dto',
  /** Company request body */
  COMPANY_FORM_DTO = 'company/company-form.dto',
  /** Compaty partial update request body */
  COMPANY_PARTIAL_FORM_DTO = 'company/company-partial-form.dto',
  /** Company group response response body */
  COMPANY_GROUP_FIND_DTO = 'company/company-group-find.dto',
  /** Standard company group search query */
  COMPANY_GROUP_QUERY_DTO = 'company/company-group-query.dto',
  /** Company group creation */
  COMPANY_GROUP_FORM_DTO = 'company/company-group-form.dto',
}
